import type { QueryClient, QueryKey } from '@tanstack/react-query';
import type { GetMarketChartRow } from '../generated/openapi-types.gen.js';
import type { PagedData } from '../types/PagedData.js';

export type MarketChartSnapshot = PagedData<GetMarketChartRow>;

/** Read an existing chart identity for a presentation-only opening frame. */
export function readMarketChartSnapshot(
  client: Pick<QueryClient, 'getQueryData'>,
  queryKey: QueryKey,
): MarketChartSnapshot | undefined {
  return client.getQueryData<MarketChartSnapshot>(queryKey);
}
